module.exports = __webpack_public_path__ + "img/15ne.4ba5aa74.svg";